export const AVAILABLE_LANGS = ['en', 'es', 'de'] as const;
export type AppLang = (typeof AVAILABLE_LANGS)[number];
export const DEFAULT_LANG: AppLang = 'en';
export const LANG_STORAGE_KEY = 'amvara.lang';

export function isAppLang(value: string | null | undefined): value is AppLang {
  return !!value && (AVAILABLE_LANGS as readonly string[]).includes(value);
}

export function detectPreferredLang(): AppLang {
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY);
    if (isAppLang(stored)) {
      return stored;
    }
  } catch {
    // ignore storage errors
  }

  const nav = (typeof navigator !== 'undefined' && navigator.language
    ? navigator.language
    : DEFAULT_LANG
  ).toLowerCase();

  if (nav.startsWith('es')) {
    return 'es';
  }
  if (nav.startsWith('de')) {
    return 'de';
  }
  return DEFAULT_LANG;
}

export function persistLang(lang: AppLang): void {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    // ignore storage errors
  }
}
